import { CustomerReportGroup } from "types";
import fetchWithRetry from "./fetch-retry";

export const fetchCustomerReportGroups = async () =>
    await fetchWithRetry('/api/customer-report-groups', { method: 'GET' }, []);

export const getCustomerReportGroupById = async (id: number): Promise<CustomerReportGroup | null> =>
    await fetchWithRetry(`/api/customer-report-groups/${id}`, { method: 'GET' }, null);

export const saveCustomerReportGroup = async (group: CustomerReportGroup): Promise<CustomerReportGroup | null> =>
    await fetchWithRetry(
        '/api/customer-report-groups',
        { method: 'POST', headers: new Headers({ 'Content-Type': 'application/json' }), body: JSON.stringify(group) },
        null
    );

export const updateCustomerReportGroup = async (group: CustomerReportGroup): Promise<CustomerReportGroup | null> =>
    await fetchWithRetry(
        `/api/customer-report-groups/${group.id}`,
        { method: 'PUT', headers: new Headers({ 'Content-Type': 'application/json' }), body: JSON.stringify(group) },
        null
    );

export const deleteCustomerReportGroup = async (id: number) =>
    await fetchWithRetry(`/api/customer-report-groups/${id}`, { method: 'DELETE' }, null)
